<template>
  <b-row>
    <b-col :md="cols" cols="12" class="pr-0 mb-2 mb-md-0" v-if="!hideName">
      <b-form-input v-model="searchName" :placeholder="namePlaceholder" size="sm" @keyup.enter="onSearch" @blur="onSearch" :autocomplete="autocomplete" />
    </b-col>
    <b-col :md="cols" cols="12" class="pr-0 mb-2 mb-md-0" v-if="!hideEmail">
      <b-form-input v-model="searchEmail" :placeholder="emailPlaceholder" size="sm" @keyup.enter="onSearch" @blur="onSearch" :autocomplete="autocomplete" />
    </b-col>
    <b-col :md="cols" cols="12" class="pr-0 mb-2 mb-md-0" v-if="!hideMobile">
      <b-form-input v-model="searchMobile" :placeholder="mobilePlaceholder" size="sm" @keyup.enter="onSearch" @blur="onSearch" :autocomplete="autocomplete" />
    </b-col>
    <b-col class="col-auto">
      <b-button :variant="searchExists ? 'primary' : 'outline-primary'" size="sm" @click="onSearch" :disabled="disabled" class="mb-2 mb-md-0">
        <i class="fa fa-fw fa-search"></i>
      </b-button>
      <b-button size="sm" v-show="searchExists" variant="link" class="text-danger" @click="onResetSearch">
        <i class="fa fa-fw fa-times"></i>
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
  export default {
    props: {
      value: {
        type: Object,
        default: {
          name: null,
          email: null,
          mobile: null,
        },
      },
      namePlaceholder: {
        type: String,
        default: 'Harry Potter',
      },
      emailPlaceholder: {
        type: String,
        default: 'harry@hogwarts.com',
      },
      mobilePlaceholder: {
        type: String,
        default: '555-123-1234',
      },
      hideName: {
        type: Boolean,
        default: false,
      },
      hideEmail: {
        type: Boolean,
        default: false,
      },
      hideMobile: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      autocomplete: String, // off
    },
    data() {
      return {
        trans: trans,
        searchName: this.value ? (this.value.name || null) : null,
        searchEmail: this.value ? (this.value.email || null) : null,
        searchMobile: this.value ? (this.value.mobile || null) : null,
        showSearch: true,
      }
    },
    computed: {
      search() {
        return {
          name: (this.searchName||'').trim() || null,
          email: (this.searchEmail||'').trim() || null,
          mobile: (this.searchMobile||'').trim() || null,
        }
      },
      searchExists() {
        return !!this.search.name || !!this.search.email || !!this.search.mobile
      },
      cols() {
        let count = 0
        if (this.hideName) count += 1
        if (this.hideMobile) count += 1
        if (this.hideEmail) count += 1
        return count == 2 ? 6 : (count == 1 ? 4: 3)
      },
    },
    watch: {
      value: {
        deep: true,
        handler() {
          this.searchName = this.value ? (this.value.name || null) : null
          this.searchEmail = this.value ? (this.value.email || null) : null
          this.searchMobile = this.value ? (this.value.mobile || null) : null
        },
      },
    },
    methods: {
      onSearch() {
        if (!_.isEqual(this.value, this.search)) {
          this.$emit('input', this.search)
        }
      },
      onResetSearch() {
        this.searchName = null
        this.searchEmail = null
        this.searchMobile = null
        this.$emit('input', this.search)
      },
    },
    mounted() {
      window.searchForm = this
    },
  }
</script>
